import { observable, action } from 'mobx';
import { IOrgAssetsData } from '../../../interfaces/OrgAssets/IOrgAssetsData';
import { IOrgAssetsItem } from '../../../interfaces/OrgAssets/IOrgAssetsItem';
import OrgAssetsService from '../../../services/OrgAssetsService';
import { ErrorResponse } from '../../../interfaces/OrgAssets/ErrorResponse';
import ThemeService from '../../../services/ThemeService';

export class OrgAssetsAdminStore {
  @observable public environment: "Development" | "Test" | "Production";
  @observable public tenant: string;
  @observable public token: string;

  @observable public loading: boolean;
  @observable public saving: boolean;
  @observable public deleting: boolean;

  @observable public isAddMode: boolean;
  @observable public isEditMode: boolean;
  @observable public isDeleteMode: boolean;

  @observable public orgAssets: IOrgAssetsData;
  @observable public orgAssetSelected: IOrgAssetsItem;

  @observable public errorMessage: string;

  @observable public cdnDisabled: boolean;

  @action public async getOrgAssets(): Promise<void> {
    this.loading = true;
    // Get tenant orgAssets
    let orgAssets = await OrgAssetsService.getOrgAssets(this.environment, this.token, this.tenant);
    this.orgAssets = orgAssets;
    this.loading = false;
    
    // if there are no org assets check whether cdn is enabled
    if(!orgAssets?.url){
        let cdnStatus = await ThemeService.getCdnStatus(this.environment, this.token, this.tenant);
        this.cdnDisabled = !cdnStatus.private?.Value && !cdnStatus.public?.Value;
    }
  }

  @action public reset(): void {
    const original: IOrgAssetsItem = JSON.parse(localStorage.getItem("IntraActive_OrgAsset_Selected"));
    this.orgAssets.orgAssetsLibraries.items.forEach((item, index) => {
      if (item.id == original.id) {
        this.orgAssets.orgAssetsLibraries.items[index] = original;
      }
    });
    localStorage.removeItem("IntraActive_OrgAsset_Selected");
  }

  @action public isChanged(): boolean {
    if (this.isAddMode) {
      return true;
    }
    // Check original version for changes
    const originalItem: IOrgAssetsItem = JSON.parse(localStorage.getItem("IntraActive_OrgAsset_Selected"));
    if (originalItem) {
      if (originalItem.displayName != this.orgAssetSelected.displayName) {
        return true;
      }
      if (originalItem.libraryUrl?.decodedUrl != this.ensureAbsoluteUrl(this.tenant, this.orgAssetSelected.libraryUrl?.decodedUrl)) {
        return true;
      }
      if (originalItem.thumbnailUrl?.decodedUrl != this.ensureAbsoluteUrl(this.tenant, this.orgAssetSelected.thumbnailUrl?.decodedUrl)) {
        return true;
      }
    }
    return false;
  }

  @action public ensureAbsoluteUrl(tenant: string, url: string): string {
    if (url && url.indexOf(`https://${tenant}.sharepoint.com`) === -1) {
      url = `https://${tenant}.sharepoint.com${url}`;
    }
    return url;
  }

  @action public setErrorMessage(response: void | ErrorResponse): void {
    if (response) {
      this.errorMessage = response.message;
    }
  }
}